export default "__VITE_ASSET__BBk7m1J7__"